import { render } from "./Approval.vue?vue&type=template&id=00a51506&scoped=true&ts=true"
import script from "./Approval.vue?vue&type=script&lang=ts"
export * from "./Approval.vue?vue&type=script&lang=ts"

import "./Approval.vue?vue&type=style&index=0&id=00a51506&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a51506"]])

export default __exports__